<template>
  <div class="select-page">
    <a-select
      style="width: 100%"
      dropdownClassName="select-drop-down"
      @change="handleChange"
      :value="selectedSize"
    >
      <div slot="dropdownRender" slot-scope="menu">
        <v-nodes :vnodes="menu" />
        <div style="padding: 4px 8px; cursor: pointer" @click="userDesign">
          <div class="edit-size">自定义尺寸</div>
        </div>
      </div>
      <a-select-opt-group v-for="(group, index) in optGroup" :key="index + 1">
        <span slot="label">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span class="line" />{{ group.label }} <span class="line" />
          </div>
        </span>
        <a-select-option
          v-for="item in group.dataList"
          :key="item.phoneSize"
          :value="item.phoneSize"
        >
          <div class="select-div">
            <div class="select-div-text">{{ item.phoneName }}</div>
            <div class="select-div-num">{{ item.phoneSize }}</div>
          </div>
        </a-select-option>
      </a-select-opt-group>
    </a-select>
    <a-modal
      v-model="visible"
      title="自定义尺寸"
      @ok="handleOk"
      destroyOnClos="true"
      cancelText="取消"
      okText="保存"
      @cancel="handleCancel"
    >
      <a-form :form="form" labelAlign="left">
        <a-row>
          <a-col :span="19" :offset="4">
            <a-form-item
              label="名称"
              :label-col="labelCol1"
              :wrapper-col="wrapperCol1"
            >
              <a-input
                v-decorator="[
                  'name',
                  {
                    rules: [{ required: true, message: '请输入名称!' }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="10" :offset="4">
            <a-form-item
              label="尺寸"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-input
                v-decorator="[
                  'width',
                  {
                    rules: [{ required: true, message: '请输入宽度!' }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :wrapper-col="wrapperCol2">
              <a-input
                v-decorator="[
                  'height',
                  {
                    rules: [{ required: true, message: '请输入高度!' }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import componentApi from "@/request/api-manager/component.js";
import projectApi from "@/request/api-manager/project.js";
export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
    project: {
      type: Object,
      default: (() => {})
    },
    page: {
      type: Object,
      default: (() => {})
    }
  },
  data() {
    return {
      projectParams: {},
      selectedSize: undefined,
      // project: {},
      projectId: "",
      labelCol1: { span: 4 },
      wrapperCol1: { span: 16 },
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      wrapperCol2: { span: 24 },
      form: this.$form.createForm(this, { name: "userDesign" }),
      visible: false,
      optGroup: [
        {
          key: "1",
          label: "移动端",
          dataList: [
            {
              phoneName: "iphone8",
              phoneSize: "375 × 667",
            },
            {
              phoneName: "iphone8 plus",
              phoneSize: "414 × 736",
            },
            {
              phoneName: "iphone SE",
              phoneSize: "320 × 568",
            },
            {
              phoneName: "ipone 11 pro",
              phoneSize: "375 × 812",
            },
            {
              phoneName: "ipone 11",
              phoneSize: "414 × 896",
            },
          ],
        },
        {
          key: "2",
          label: "平板",
          dataList: [
            {
              phoneName: "平板",
              phoneSize: "768 × 1024",
            },
          ],
        },
        {
          key: "3",
          label: "web端",
          dataList: [
            {
              phoneName: "Apple TV",
              phoneSize: "1920 × 1080",
            },
            {
              phoneName: "MacBook Pro",
              phoneSize: "1440 × 900",
            },
            {
              phoneName: "pc电脑",
              phoneSize: "1366 × 768",
            },
          ],
        },
        {
          key: "4",
          label: "自定义",
          dataList: [],
        },
      ],
    };
  },
  // watch: {
  //   page
  // },
  created() {
    
  },
  methods: {
    getSize(){
      
      // let id = self.$route.query.pageId;
      // componentApi.queryById({ id }).then((res) => {
      //   self.projectId = res.result.projectId;
      //   projectApi.queryById({ id: self.projectId }).then((res) => {
          // self.project = res.result;
          // if (!res.result) {
          //   self.$message.error('未找到该页面所属项目') 
          //   return
          // }
      let self = this;
      let params = self.project.params || "{}"
      // if (!self.page.params) {
      //   res.result.params = "{}";
      // }
      self.projectParams = JSON.parse(params);
      self.selectedSize = self.projectParams.selectedSize || "320 × 568";
        
      console.log('默认值你就给我出',self.selectedSize )
      self.stringSplitAndBus(self.selectedSize);
      self.optGroup[3].dataList = self.projectParams.sizeDesignByCustom || [];
              
      //   });
      // });
    },
    userDesign() {
      let self = this;
      self.visible = true;
    },
    stringSplitAndBus(value) {
      let self = this;
      var idstr = value.split(" × ");
      let width = idstr[0];
      let height = idstr[1];
      self.$eventBus.$emit("size", width, height);
    },
    handleOk() {
      let self = this;
      self.form.validateFields((err, values) => {
        if (!err) {
          let size = self.form.getFieldsValue();
          let phoneNameTemporary = size.name;
          let phoneSizeTemporary = size.width + " × " + size.height;
          let data = {
            phoneName: phoneNameTemporary,
            phoneSize: phoneSizeTemporary,
          };
          let projectParams = self.projectParams
          projectParams.sizeDesignByCustom ? 
            projectParams.sizeDesignByCustom.push(data) : 
            projectParams.sizeDesignByCustom = [data]
          self.optGroup[3].dataList = projectParams.sizeDesignByCustom

          self.$emit("setProjectParams", JSON.stringify(self.projectParams))

          // self.project.params = JSON.stringify(self.projectParams);
          projectApi.edit(self.project).then((res) => {
            if (res.success) {
              self.$message.success("自定义成功");
            }
          });
          console.log("自定义值", self.project.params);
          self.form.resetFields();
          self.visible = false;
        }
      });
    },
    handleCancel() {
      let self = this;
      self.form.resetFields();
      self.visible = false;
    },
    handleChange(value) {
      let self = this;
      console.log(`selected ${value}`);
      self.stringSplitAndBus(value);
      self.selectedSize = value;
      self.projectParams.selectedSize = value;
      self.$emit("setProjectParams", JSON.stringify(self.projectParams))
      // self.project.params = JSON.stringify(self.projectParams);
      projectApi.edit(self.project).then((res) => {
        if (res.success) {
          console.log("成功");
        }
      });
    },
  },
};
</script>
<style scoped>
@import "index.css";
</style>